var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorse1Female(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 100,
    viewBox: "0 0 90 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8240_8344)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8240_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1718 72.1299C42.1718 72.1299 43.5178 72.8655 44.9891 72.7403C46.4603 72.6151 47.0238 72.4585 47.0238 72.4585C47.0238 72.4585 52.5645 60.1564 59.6233 54.6314C66.6822 49.0907 70.1412 46.1169 70.1412 46.1169L67.6839 37.6338C67.6839 37.6338 63.1762 43.331 56.54 45.1778C49.9037 47.0247 40.904 47.8699 33.7669 45.8352C26.6298 43.8005 21.543 39.2303 21.543 39.2303L18.9136 48.6995C18.9136 48.6995 23.6873 50.2333 30.1045 56.7913C36.5059 63.3493 42.1875 72.1455 42.1875 72.1455L42.1718 72.1299Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.359 13.9056C23.359 13.9056 29.3222 11.6205 42.047 11.0414C54.7717 10.4623 62.6288 12.8883 62.6288 12.8883L63.4114 7.03457C63.4114 7.03457 67.0895 -0.024292 66.9956 -3.6085C66.9017 -7.17706 64.2879 -11.1995 63.9905 -15.6602C63.7087 -20.1209 64.0687 -27.9623 64.0687 -27.9623L59.8428 -28.8545C59.8428 -28.8545 57.1977 -16.7245 44.2851 -17.2097C31.3726 -17.6949 28.3205 -23.799 27.7571 -29.4336L22.5764 -27.9467C22.5764 -27.9467 23.9537 -22.453 22.3573 -16.521C22.3573 -16.521 19.587 -8.50744 19.5244 -1.22946C19.4931 1.66608 21.1834 4.45206 21.6686 6.56502L23.3746 13.9213L23.359 13.9056Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2091 -11.6855C20.8229 -8.77435 19.2734 -5.2058 19.4769 -1.24595C19.8682 2.58869 20.6351 3.99733 21.7151 6.15725C23.5463 13.4352 23.2802 24.7357 23.0768 26.1913C22.5446 30.0259 21.9812 38.603 19.6491 44.8949C19.43 45.4897 18.8195 47.9782 18.3813 50.1851C17.5674 54.2389 17.6613 57.4318 17.7552 58.637C17.7552 58.637 18.0057 64.2872 18.0839 67.1984C18.1622 70.1096 19.0074 95.1208 19.5395 98.7207",
    stroke: "#2E2E2E",
    strokeWidth: 0.292044,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7014 -11.6855C68.2318 -11.1064 67.3866 -9.91692 67.0423 -8.17959C66.7762 -6.86486 66.9014 -5.7536 67.0423 -5.06493C67.0736 -3.7502 66.964 -1.99722 66.4632 -0.00947191C65.7276 2.82346 64.4755 4.92077 63.552 6.2042C63.2233 7.67545 62.8477 9.85102 62.6755 12.5118C62.4564 16.049 63.552 21.668 67.4336 36.5056C70.2196 47.1644 71.0178 49.1052 71.2682 55.444C71.2682 55.444 71.4874 88.5471 70.5013 98.7207",
    stroke: "#2E2E2E",
    strokeWidth: 0.292044,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.751 36.6782C42.751 35.5982 43.3457 34.7061 44.0657 34.7061C44.7857 34.7061 45.3804 35.5825 45.3804 36.6782",
    stroke: "#2E2E2E",
    strokeWidth: 0.292044,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6997 6.17285C21.6997 6.17285 23.6249 8.72406 27.2404 8.36407",
    stroke: "#2E2E2E",
    strokeWidth: 0.292044,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5521 6.18848C63.5521 6.18848 61.7521 8.58316 57.3384 8.37969",
    stroke: "#2E2E2E",
    strokeWidth: 0.292044,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3125 99.7074C43.3612 94.1041 43.7994 87.2487 43.2516 79.5012L42.7351 72.458C43.2829 72.6928 43.6742 72.6145 44.5976 72.7084C46.2723 72.8806 46.2254 72.8806 46.9141 72.5832C46.3976 76.4648 46.9141 80.2994 46.7575 84.948C46.5854 90.0347 47.1958 95.3719 47.5088 99.5822",
    stroke: "#2E2E2E",
    strokeWidth: 0.292044,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.3073 78.4614L76.2096 30.2452",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeDasharray: "4.63 4.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30489 78.5216L11.4077 30.2358",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeDasharray: "4.63 4.63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8240_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8240_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 156,
    fill: "white",
    transform: "translate(15.1948 -55.6504)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorse1Female);
export default __webpack_public_path__ + "static/media/torse-1-female.bb2b887a7d8077a9670095b76f94a94c.svg";
export { ForwardRef as ReactComponent };